import React from "react";

function FormPageStyles() {
    return <style>
        {`
          @media (max-width: 3000px) and (min-width: 2049px) {
            body {
              background: linear-gradient(to left, #F6F9FF 42%, #fff 42%);
            }
            body.dark {
              background: linear-gradient(to left, #1e2736 42%, #171d27 42%);
            }
          }
          @media (max-width: 2048px) and (min-width: 1921px) {
            body {
              background: linear-gradient(to left, #F6F9FF 40%, #fff 40%);
            }
            body.dark {
              background: linear-gradient(to left, #1e2736 40%, #171d27 40%);
            }
          }
          @media (max-width: 1920px) and (min-width: 1367px) {
            body {
              background: linear-gradient(to left, #F6F9FF 39%, #fff 39%);
            }
            body.dark {
              background: linear-gradient(to left, #1e2736 39%, #171d27 39%);
            }
          }
          @media (max-width: 1366px) and (min-width: 992px) {
            body {
              background: linear-gradient(to left, #F6F9FF 34%, #fff 34%);
            }
            body.dark {
              background: linear-gradient(to left, #1e2736 34%, #171d27 34%);
            }
          }
          @media (max-width: 991px) {
            body.dark {
              background: #171d27;
            }
          }
        `}
    </style>;
}

export default FormPageStyles;
